<template>
  <div
    class="flex flex-col items-center absolute bottom-0 h-96 w-72 bg-primary-900 rounded-xl shadow-lg p-4 me-8 mb-8 z-40"
    :class="[
      { 'left-0': currentLocal === 'ar' },
      { 'right-0': currentLocal === 'en' },
      { 'shake-animation': !isAnswered && isIncoming },
    ]"
  >
    <Button
      v-show="isMinimised && !isAdminCall"
      class="text-white w-fit self-end"
      @click="$emit('maximise')"
    >
      <v-icon>mdi-fullscreen</v-icon>
    </Button>
    <div class="flex flex-col flex-1 justify-between items-center w-full">
      <call-actions />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useLocale } from 'vuetify';
import CallActions from './CallActions.vue';
import { Button } from 'primevue';

export default {
  name: 'MinimizedCallWindow',
  components: { CallActions, Button },
  props: {
    isMinimised: {
      type: Boolean,
      default: false
    },
    isAdminCall: {
      type: Boolean,
      default: false
    }
  },
  emits: ['maximise'],
  setup() {
    const store = useStore();
    const { current } = useLocale();

    const currentLocal = computed(() => current.value);

    const isAnswered = computed(() => store.getters.isAnswered);
    const isIncoming = computed(() => store.getters.isIncoming);

    return {
      currentLocal,
      isAnswered,
      isIncoming
    };
  }
};
</script>

<style scoped>
@keyframes shake {
  0%,
  100% {
    transform: rotate(0deg);
  }
  5%,
  15% {
    transform: rotate(-3deg);
  }
  10%,
  20% {
    transform: rotate(3deg);
  }
  25%,
  75% {
    transform: rotate(0deg);
  }
}

.shake-animation {
  animation: shake 2s ease-in-out infinite;
  transform-origin: center bottom;
}
</style> 